module.exports = __webpack_public_path__ + "img/intensives-3.e6d56baf.png";